import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';

import { HeaderStateService } from './main/headers/services/header-state.service';
import { UserAuthorizationService } from './security/services/user-authorization.service';
import { SponsorsStateService } from './shared/components/sponsors/services/sponsors-state.service';
import { SharedPushNotificationService } from './shared/services/shared-push-notification.service';
import { VersionUpdateService } from './shared/services/version-update.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    title = 'web-staff-app';

    constructor(
        protected headerStateService: HeaderStateService,
        protected sponsorsStateService: SponsorsStateService,
        // the VersionUpdateService is needed here for startup
        private versionUpdateService: VersionUpdateService,
        // the SharedPushNotificationService is needed here for startup
        private sharedPushNotificationService: SharedPushNotificationService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private userAuthorizationService: UserAuthorizationService
    ) {
    }

    async ngOnInit() {
        await this.userAuthorizationService.loadUserAsync();
    }
}
